import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { houzyContact } from '../../../lib/houzyContact';

function ContactLink({ href, icon, children }: { href: string; icon: ReactNode; children: string }): ReactElement {
    return (
        <Link
            href={href}
            variant="body2"
            underline="hover"
            sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, fontWeight: 600 }}>
            {icon}
            {children}
        </Link>
    );
}

export function CheckoutContact(): ReactElement {
    const { t } = useTranslation();

    return (
        <Stack spacing={1.5} sx={{ alignItems: 'center', textAlign: 'center' }}>
            <Stack spacing={0.5}>
                <Typography variant="subtitle2" component="p">
                    {t('CHECKOUT.CONTACT.TITLE')}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {t('CHECKOUT.CONTACT.BODY')}
                </Typography>
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 1, sm: 3 }} sx={{ alignItems: 'center' }}>
                <ContactLink
                    href={houzyContact.partnerManagementPhoneHref}
                    icon={<PhoneOutlinedIcon sx={{ fontSize: 18 }} />}>
                    {houzyContact.partnerManagementPhoneNumber}
                </ContactLink>
                <ContactLink
                    href={`mailto:${houzyContact.supportEmail}`}
                    icon={<EmailOutlinedIcon sx={{ fontSize: 18 }} />}>
                    {houzyContact.supportEmail}
                </ContactLink>
            </Stack>
        </Stack>
    );
}
